<script setup lang="ts">
import Toggle from "@/dsComponents/Toggle/Toggle.vue";

interface AvailabilityToggleCardProps {
    label: string;
    active: boolean;
    disabled?: boolean;
}

withDefaults(defineProps<AvailabilityToggleCardProps>(), {
    disabled: false,
});

const emit = defineEmits<{
    input: [];
}>();
</script>

<template>
    <div class="availability-toggle-card">
        <div class="availability-toggle-card__row">
            <span class="availability-toggle-card__label typo-xxs-medium">{{ label }}</span>
            <div class="availability-toggle-card__toggle">
                <Toggle size="sm" :active="active" :disabled="disabled" @input="emit('input')" />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.availability-toggle-card {
    border-radius: var(--radius-xl, 12px);
    border: 1px solid var(--stroke-soft-200, #dbdfe6);
    background-color: var(--bg-white-0, #ffffff);
    box-shadow: var(--regular-shadow-xs, 0px 1px 2px #dbdfe640);
    padding: var(--spacing-md, 8px);

    &__row {
        display: flex;
        min-height: 36px;
        align-items: center;
        justify-content: space-between;
        gap: var(--spacing-sm, 6px);
        padding: 0 var(--spacing-md, 8px);
    }

    &__label {
        flex: 1 1 auto;
        min-width: 0;
        padding: 0 var(--spacing-xs, 4px);
        color: var(--text-main-900, #00061a);
    }

    &__toggle {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 48px;
        min-height: 28px;
        padding: 0 var(--spacing-md, 8px);
    }
}
</style>
